console.log(isPDFJSCompatible());
import * as pdfjsLib from 'pdfjs-dist/webpack';
// If absolute URL from the remote server is provided, configure the CORS header on that server.
let gScale = 2;
let iframe = document.querySelector('iframe');
let iframeBttns = document.querySelectorAll('.iframe-button');
let showPdfBttns = document.querySelectorAll('.show-pdf-btn');
let clearPdfBttns = document.querySelectorAll('.clear-pdf-btn');
let hideIframeBttns = document.querySelectorAll('.hide-iframe-btn');
let pdfContainers = document.querySelectorAll('.pdf-container');
let zoomInButton = document.getElementById('pdf-zoom-in');
let zoomOutButton = document.getElementById('pdf-zoom-out');
const MAX_CANVAS_PIXELS = 16777216;
const LOWEST_SAFARI_IOS_VERSION = 16.4;
let printBttns = document.querySelectorAll('.print-pdf-btn');
let printBtn = document.querySelector('.open-to-new-tab-btn');
let openToNewTabBttns = document.querySelectorAll('.open-to-new-tab-btn');

// The workerSrc property shall be specified.
pdfjsLib.GlobalWorkerOptions.workerSrc =
  '//mozilla.github.io/pdf.js/build/pdf.worker.mjs';

// Add event listeners for clear PDF buttons
if (clearPdfBttns) {
  clearPdfBttns.forEach((btn) => {
    btn.addEventListener('click', () => {
      pdfContainers.forEach((container) => {
        container.classList.add('hidden');
        if (zoomInButton) zoomInButton.classList.add('hidden');
        if (zoomOutButton) zoomOutButton.classList.add('hidden');
        // if (printBtn) printBtn.classList.add('hidden');
      });
    });
  });
}

// Add event listeners for show PDF buttons
if (showPdfBttns) {
  showPdfBttns.forEach((btn) => {
    btn.addEventListener('click', () => {
      pdfContainers.forEach((container) => {
        container.classList.remove('hidden');
        if (zoomInButton) zoomInButton.classList.remove('hidden');
        if (zoomOutButton) zoomOutButton.classList.remove('hidden');
        if (printBtn) printBtn.classList.remove('hidden');
      });
    });
  });
}

// Add event listeners for iframe buttons
if (iframeBttns) {
  iframeBttns.forEach((btn) => {
    btn.addEventListener('click', () => {
      let url = btn.getAttribute('data-url');
      if (iframe) {
        iframe.src = url;
        iframe.classList.remove('hidden');
      }
    });
  });
}

// Add event listeners for hide iframe buttons
if (hideIframeBttns) {
  hideIframeBttns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (iframe) iframe.classList.add('hidden');
    });
  });
}

// Add event listeners for zoom buttons
if (zoomInButton) {
  zoomInButton.addEventListener('click', () => {
    gScale += 0.5;
    console.log(gScale);
    globalRender(gScale);
  });
}

if (zoomOutButton) {
  zoomOutButton.addEventListener('click', () => {
    gScale -= 0.5;
    if (gScale < 0.5) {
      gScale = 0.5;
    }
    console.log(gScale);
    globalRender(gScale);
  });
}

// Add event listeners for open to new tab buttons
if (openToNewTabBttns) {
  openToNewTabBttns.forEach((btn) => {
    btn.addEventListener('click', () => {
      let element = null;
      let url = null;
      if (iframe && iframe.classList.contains('hidden')) {
        element = pdfContainers[0];
        url = element.getAttribute('url');
      }else if (pdfContainers[0].classList.contains('hidden')) {
        element = iframe;
        url= element.getAttribute('src');
      }else {
        element = pdfContainers[0];
        url = element.getAttribute('url');
      }
       
      console.log(element);
      if (url) openToNewTab(url);
    });
  });
}

// Add event listeners for print buttons
if (printBttns) {
  printBttns.forEach((btn) => {
    btn.addEventListener('click', () => {
      let element = null;
      if (iframe.classList.contains('hidden')) {
        element = pdfContainers[0];
      }else if (pdfContainers[0].classList.contains('hidden')) {
        element = iframe;
      }else {
        element = pdfContainers[0];
      }
      let url = element.getAttribute('url');
      console.log(url);
      if (url) printPDF(url);
    });
  });
}

function isSafariVersionSmallerThan(aVersion) {
  const ua = navigator.userAgent;
  const match = ua.match(/Version\/(\d+\.\d+)(?:.*Safari\/(\d+\.\d+))?/);

  if (match && match[1]) {
    const safariVersion = parseFloat(match[1]);
    const targetVersion = parseFloat(aVersion);

    return safariVersion < targetVersion;
  }

  // Return false if the browser is not Safari
  return false;
}

function isPDFJSCompatible() {
  return !isSafariVersionSmallerThan(LOWEST_SAFARI_IOS_VERSION);
}

export function globalRender(scale = 2, fill = false) {
  if (!scale) {
    scale = gScale;
  }
  pdfContainers.forEach((container) => {
    container.innerHTML = '';
    loadAndRenderPDF(container, scale, fill);
  });
}

// print function pdfjsLib
function printPDF(pdfUrl) {
  if (!pdfUrl) {
    console.error('No PDF URL provided for printing');
    return;
  }

  // Create a hidden iframe
  const iframe = document.createElement('iframe');
  iframe.className = 'hidden';
  iframe.style.position = 'absolute';
  iframe.style.top = '-9999px';
  iframe.style.left = '-9999px';

  // Add iframe to the document
  document.body.appendChild(iframe);

  // Load the PDF document into the iframe and trigger print
  pdfjsLib
    .getDocument(pdfUrl)
    .promise.then((pdf) => {
      const totalPages = pdf.numPages;

      // Prepare the print content
      const printContent = document.createElement('div');
      printContent.style.margin = '0'; // Remove margins
      printContent.style.padding = '0'; // Remove padding

      const renderPage = async (pageNumber) => {
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1 });

        // Create a canvas for the page
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        // Set canvas dimensions to fit the page
        const scale = 1.5; // Adjust this value as needed for better quality
        canvas.width = viewport.width * scale;
        canvas.height = viewport.height * scale;

        await page.render({
          canvasContext: context,
          viewport: page.getViewport({ scale }),
        }).promise;

        // Add styles to make the content fill the page
        canvas.style.width = '100%';
        canvas.style.height = '100%';

        // Append canvas to print content
        printContent.appendChild(canvas);
      };

      // Render all pages sequentially
      const renderPromises = [];
      for (let i = 1; i <= totalPages; i++) {
        renderPromises.push(renderPage(i));
      }

      Promise.all(renderPromises).then(() => {
        // Apply CSS to iframe for full-page printing
        const style = document.createElement('style');
        style.textContent = `
        body {
          margin: 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        canvas {
          page-break-after: always;
        }
      `;
        iframe.contentDocument.head.appendChild(style);

        iframe.contentDocument.body.innerHTML = '';
        iframe.contentDocument.body.appendChild(printContent);

        // Print the iframe content
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Cleanup
        document.body.removeChild(iframe);
      });
    })
    .catch((error) => {
      console.error('Error loading PDF for printing:', error);
    });
}

// Function to load and render the PDF
async function loadAndRenderPDF(container, scale, fill = false) {
  try {
    let pdfUrl = container.getAttribute('url');
    if (!pdfUrl) {
      console.error('No PDF URL provided');
      return;
    }
    // Load the PDF document
    const pdf = await pdfjsLib.getDocument(pdfUrl).promise;

    // Loop through all pages
    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      // Load the page
      const page = await pdf.getPage(pageNumber);

      // Set scale for rendering
      const viewport = page.getViewport({ scale });
      // if (viewport.width < MAXWIDTH || viewport.height < MAXHEIGHT) {
      //   container.style.width = ${viewport.width}px;
      //   container.style.height = ${viewport.height}px;
      // }

      // Create a canvas element for the page
      const canvas = document.createElement('canvas');
      canvas.className = 'pdf-page';
      container.appendChild(canvas);

      const outputScale = new OutputScale();
      const maxCanvasPixels = MAX_CANVAS_PIXELS;
      const { width, height } = viewport;
      // Set canvas dimensions
      const context = canvas.getContext('2d', { alpha: false });
      // canvas.width = viewport.width;
      // canvas.height = viewport.height;
      if (maxCanvasPixels > 0) {
        const pixelsInViewport = width * height;
        const maxScale = Math.sqrt(maxCanvasPixels / pixelsInViewport);
        if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
          outputScale.sx = maxScale;
          outputScale.sy = maxScale;
        }
      }
      const sfx = approximateFraction(outputScale.sx);
      const sfy = approximateFraction(outputScale.sy);
      canvas.width = roundToDivide(width * outputScale.sx, sfx[0]);
      canvas.height = roundToDivide(height * outputScale.sy, sfy[0]);
      if (fill == false) {
        const { style } = canvas;
        style.width = roundToDivide(width, sfx[1]) + 'px';
        style.height = roundToDivide(height, sfy[1]) + 'px';
      }

      const transform = outputScale.scaled
        ? [outputScale.sx, 0, 0, outputScale.sy, 0, 0]
        : null;
      const renderContext = {
        canvasContext: context,
        transform,
        viewport,
      };

      var renderTask = page.render(renderContext);
      renderTask.promise.then(function () {
        console.log('Page rendered');
      });
    }
  } catch (error) {
    console.error('Error loading or rendering PDF:', error);
  }
}

function roundToDivide(x, div) {
  const r = x % div;
  return r === 0 ? x : Math.round(x - r + div);
}

function openToNewTab(url) {
  // Open the PDF in a new window
  window.open(url, '_blank');
}

function approximateFraction(x) {
  // Fast paths for int numbers or their inversions.
  if (Math.floor(x) === x) {
    return [x, 1];
  }
  const xinv = 1 / x;
  const limit = 8;
  if (xinv > limit) {
    return [1, limit];
  } else if (Math.floor(xinv) === xinv) {
    return [1, xinv];
  }

  const x_ = x > 1 ? xinv : x;
  // a/b and c/d are neighbours in Farey sequence.
  let a = 0,
    b = 1,
    c = 1,
    d = 1;
  // Limiting search to order 8.
  while (true) {
    // Generating next term in sequence (order of q).
    const p = a + c,
      q = b + d;
    if (q > limit) {
      break;
    }
    if (x_ <= p / q) {
      c = p;
      d = q;
    } else {
      a = p;
      b = q;
    }
  }
  let result;
  // Select closest of the neighbours to x.
  if (x_ - a / b < c / d - x_) {
    result = x_ === x ? [a, b] : [b, a];
  } else {
    result = x_ === x ? [c, d] : [d, c];
  }
  return result;
}
class OutputScale {
  constructor() {
    const pixelRatio = window.devicePixelRatio || 1;
    this.sx = pixelRatio;
    this.sy = pixelRatio;
  }

  get scaled() {
    return this.sx !== 1 || this.sy !== 1;
  }
}
